
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { memo } from "react";

interface ModalProps {
  modalOpen: boolean;
  closeModal: () => void;
  title: string;
  description?: string;
  width?: string;
  buttonText?: string;
  cancelText?: string;
  onButtonClick?: () => void;
  isVariant?: boolean;
  isLoading?: boolean;
  waitDescription?: string;
  fontsize?: string;
}

const ConfirmModal: React.FC<ModalProps> = ({
  modalOpen,
  closeModal,
  title,
  description,
  width,
  buttonText,
  cancelText = "cancel",
  onButtonClick,
  isVariant,
  isLoading,
  waitDescription,
  fontsize,
}) => {
  return (
    <Dialog
      open={modalOpen}
      onClose={closeModal}
      fullWidth
      maxWidth={false}
      slotProps={{
        paper: {
          style: { width: width || "500px" },
        },
      }}
    >
      <DialogTitle
        variant="h5"
        sx={{
          fontSize: "1.3rem",
          fontWeight: 700,
          color: "#48465b"
        }}
      >
        {title.toUpperCase()}
      </DialogTitle>
      <DialogContent dividers style={{ padding: "40px 30px", fontSize: fontsize || "1.2rem" }}>
        {isLoading ? waitDescription : description}
      </DialogContent>
      <DialogActions>
        <Button
          style={{ color: "black" }}
          onClick={closeModal}
        >
          {cancelText}
        </Button>
        <Button
          variant={isVariant ? "contained" : "text"}
          onClick={onButtonClick || closeModal}
          disabled={isLoading ? true : false}
        >
          {buttonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default memo(ConfirmModal);
